import { useConfig } from 'src/providers/ConfigProvider';

import { ICustomText } from 'src/types/Strings';

type ValidCustomTextStringKey = keyof Omit<ICustomText, 'faq1' | 'faq2' | 'faq3' | 'faq4' | 'faq5'>;

type Formatter = (value: string) => string;

export function useCustomText(
  key: ValidCustomTextStringKey,
  defaultValue: string,
  format?: Formatter
): string {
  const { customText } = useConfig();

  if (key in customText && customText[key].trim() !== '') {
    return format ? format(customText[key]) : customText[key];
  }

  return defaultValue;
}
